export const filterBoxBase =
  'flex size-[18px] shrink-0 items-center justify-center rounded-[2px] border-2';

export const filterBoxUnchecked = 'border-(--mui-palette-action-active)';

export const filterBoxChecked =
  "border-(--mui-palette-primary-main) bg-(--mui-palette-primary-main) after:mb-0.5 after:h-2.5 after:w-1.5 after:rotate-45 after:border-b-2 after:border-r-2 after:border-white after:content-['']";
